module.exports = __webpack_public_path__ + "static/media/bubble.8e466cc0.png";